/* AimGrips Video Showcase — slide switching, tabs, autoplay rotation, swipe */
(function () {
  'use strict';

  function initShowcase(root) {
    if (root.dataset.agInit === 'true') return;
    root.dataset.agInit = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ag-slide]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ag-tab]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ag-dot]'));
    if (slides.length === 0) return;

    var n = slides.length;
    var idx = 0;
    var timer = null;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var designMode = window.Shopify && window.Shopify.designMode;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && n > 1 && !reducedMotion && !designMode;

    function setBar(tab, width, ms) {
      var bar = tab && tab.querySelector('.ag-show__bar i');
      if (!bar) return;
      bar.style.transition = ms ? 'width ' + ms + 'ms linear' : 'none';
      bar.style.width = width;
    }

    function startTimer() {
      if (!autoplay) {
        if (tabs[idx]) setBar(tabs[idx], '100%', 0);
        return;
      }
      clearTimeout(timer);
      tabs.forEach(function (t) { setBar(t, '0%', 0); });
      var active = tabs[idx];
      if (active) {
        /* force reflow so the 0% width applies before animating */
        void active.offsetWidth;
        setBar(active, '100%', interval);
      }
      timer = setTimeout(function () { show(idx + 1); }, interval);
    }

    function show(i) {
      idx = ((i % n) + n) % n;
      slides.forEach(function (s, j) {
        var active = j === idx;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', String(!active));
        /* Play only the currently visible video (desktop vs mobile media swap) */
        Array.prototype.forEach.call(s.querySelectorAll('video'), function (video) {
          if (active && video.offsetParent !== null) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      });
      tabs.forEach(function (t, j) {
        var active = j === idx;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', String(active));
        t.setAttribute('tabindex', active ? '0' : '-1');
        if (active && t.scrollIntoView) {
          t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      });
      dots.forEach(function (d, j) {
        var active = j === idx;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', String(active));
      });
      startTimer();
    }

    tabs.forEach(function (tab, j) {
      tab.addEventListener('click', function () { show(j); });
      tab.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); tabs[idx].focus(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); tabs[idx].focus(); }
      });
    });
    dots.forEach(function (dot, j) {
      dot.addEventListener('click', function () { show(j); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-ag-prev]'), function (b) {
      b.addEventListener('click', function () { show(idx - 1); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-ag-next]'), function (b) {
      b.addEventListener('click', function () { show(idx + 1); });
    });

    /* Pause rotation while hovering */
    root.addEventListener('mouseenter', function () { clearTimeout(timer); });
    root.addEventListener('mouseleave', function () { startTimer(); });

    /* Touch swipe */
    var touchX = null;
    root.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; clearTimeout(timer); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 50) { show(idx + (dx < 0 ? 1 : -1)); } else { startTimer(); }
      touchX = null;
    }, { passive: true });

    /* Pause everything when scrolled off-screen */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          show(idx);
        } else {
          clearTimeout(timer);
          slides.forEach(function (s) {
            Array.prototype.forEach.call(s.querySelectorAll('video'), function (v) { v.pause(); });
          });
        }
      }, { threshold: 0.15 }).observe(root);
    }

    show(0);

    /* Theme editor: jump to the slide whose block is selected */
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target && e.target.closest ? e.target.closest('[data-ag-slide]') : null;
      if (slide && root.contains(slide)) show(slides.indexOf(slide));
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ag-showcase]'), initShowcase);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
